module.exports = __webpack_public_path__ + "img/AM4A7883.79636fb0.jpg";